import Vue from 'vue'
import 'babel-polyfill'
import Vuex from 'vuex'

Vue.use(Vuex);
const state={
  headNavLink:''
};
const mutations = {
  changeHeadNavLink(state, isChange) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
    state.headNavLink = isChange;
  },
};
const store = new Vuex.Store({
  state,
  mutations,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js